export const VERSIONS_PER_PAGE = 10;
